
import Vue, { RenderContext } from "vue";
export default Vue.extend({
  name: "UFlexWrapper",
  functional: true,
  render(h, { children, data, props }: RenderContext) {
    return h(
      "div",
      {
        class: "u-flex-wrapper",
        staticClass: data.staticClass,
        style: props
      },
      children
    );
  }
});
